let routes = [
  {
    name: 'index',
    path: '/',
    redirect: '/user'
  },
  {
    name: 'show',
    path: '/show',
    component: r => require(['views/show/show'], r)
  },
  {
    name: 'user',
    path: '/user',
    component: r => require(['views/user/user'], r),
    redirect: '/user/login',
    children: [
      {
        name: 'login',
        path: 'login',
        component: r => require(['views/user/children/login'], r)
      },
      {
        name: 'register',
        path: 'register',
        component: r => require(['views/user/children/register'], r)
      }
    ]
  },
  {
    name: 'main',
    path: '/main',
    component: r => require(['layout/mainLayout'], r),
    children: [
      {
        name: 'add',
        path: 'add',
        component: r => require(['views/add/add'], r)
      },
      {
        name: 'home',
        path: 'home',
        component: r => require(['views/home/home'], r)
      },
      {
        name: 'userManage',
        path: 'userManage',
        component: r => require(['views/user/manage'], r)
      },
      {
        name: 'registerUserManage',
        path: 'registerUserManage',
        component: r => require(['views/user/registerUserManage'], r)
      },
      {
        name: 'aging',
        path: 'aging',
        component: r => require(['views/aging/aging'], r)
      },
      {
        name: 'options',
        path: 'options',
        component: r => require(['views/options/options'], r)
      },
      {
        name: 'recover',
        path: 'recover',
        component: r => require(['views/recover/recover'], r)
      },
      {
        name: 'infrared',
        path: 'infrared',
        component: r => require(['views/infrared/infrared'], r)
      },
      {
        name: 'access',
        path: 'access',
        component: r => require(['views/access/access'], r)
      },
      // 设备资产管理
      {
        name: 'projectExpireManage',
        path: 'projectExpireManage',
        component: r => require(['views/project/projectExpireManage'], r)
      }
    ]
  },
  {
    name: 'app',
    path: '/:projectId/app',
    component: r => require(['layout/layout'], r),
    redirect: '/:projectId/app/device/map',
    children: [
      {
        name: 'device',
        path: 'device',
        redirect: '/:projectId/app/device/map'
      },
      {
        name: 'deviceList',
        path: 'device/list',
        component: r => require(['views/device/list'], r)
      },
      {
        name: 'deviceMap',
        path: 'device/map',
        component: r => require(['views/device/map'], r)
      },
      {
        name: 'monitor',
        path: 'monitor',
        component: r => require(['views/monitor/monitor'], r)
      },
      {
        name: 'warn',
        path: 'warn',
        component: r => require(['views/warn/warn'], r)
      },
      {
        name: 'strategy',
        path: 'strategy',
        component: r => require(['views/strategy/strategy'], r)
      },
      {
        name: 'group',
        path: 'group',
        component: r => require(['views/group/group'], r)
      },
      {
        name: 'project',
        path: 'project',
        component: r => require(['views/project/project'], r)
      },
      {
        name: 'recharge',
        path: 'recharge',
        component: r => require(['views/recharge/recharge'], r)
      },
      {
        name: 'wattMeter',
        path: 'wattMeter',
        component: r => require(['views/wattMeter/wattMeter'], r)
      },
      {
        name: 'external',
        path: 'external',
        component: r => require(['views/external/external'], r)
      },
      {
        name: 'deviceListRepower',
        path: 'device/listRepower',
        component: r => require(['views/device/listRepower'], r)
      },
      {
        name: 'deviceMapRepower',
        path: 'device/mapRepower',
        component: r => require(['views/device/mapRepower'], r)
      },
      {
        name: 'monitorRepower',
        path: 'monitorRepower',
        component: r => require(['views/monitor/monitorRepower'], r)
      },
      {
        name: 'warnRepower',
        path: 'warnRepower',
        component: r => require(['views/warn/warnRepower'], r)
      },
      {
        name: 'strategyRepower',
        path: 'strategyRepower',
        component: r => require(['views/strategy/strategyRepower'], r)
      },
      {
        name: 'groupRepower',
        path: 'groupRepower',
        component: r => require(['views/group/groupRepower'], r)
      },
      {
        name: 'projectRepower',
        path: 'projectRepower',
        component: r => require(['views/project/projectRepower'], r)
      },
      {
        name: 'error',
        path: 'error',
        component: r => require(['views/error/error'], r)
      },
      {
        name: 'summary',
        path: 'summary',
        component: r => require(['views/summary/summary'], r)
      },
      {
        name: 'projectData',
        path: 'projectData',
        component: r => require(['views/projectData/projectData'], r)
      },
      // {
      //   name: 'deviceMapV300',
      //   path: 'device/mapV300',
      //   component: r => require(['views/device/V300/device/index'], r)
      // },
      // {
      //   name: 'monitorMapV300',
      //   path: 'monitor/mapV300',
      //   component: r => require(['views/device/V300/monitor/index'], r)
      // },
      // {
      //   name: 'warnMapV300',
      //   path: 'warn/mapV300',
      //   component: r => require(['views/device/V300/warn/index'], r)
      // },
      // {
      //   name: 'strategyMapV300',
      //   path: 'strategy/mapV300',
      //   component: r => require(['views/device/V300/strategy/index'], r)
      // },
    ]
  },
  // 充值订单管理
  {
    name: 'voucher',
    path: '/voucher',
    component: r => require(['views/voucher/voucher'], r),
    redirect: '/voucher/order',
    children: [
      {
        name: 'order',
        path: '/voucher/order',
        component: r => require(['views/voucher/order'], r)
      },
      {
        name: 'commodity',
        path: '/voucher/commodity',
        component: r => require(['views/voucher/commodity'], r)
      }
    ]
  }
]

// const routesModules = require.context('./modules', false, /\.js$/)
// routesModules.keys().forEach(item => {
//   const route = routesModules(item).default
//   routes = routes.concat(route)
// })

export default routes
